import { useEffect, useRef, useState } from "react";
import EditInputComponent from "../EditInputComponent/EditInputComponent";
import { TiDelete } from "react-icons/ti";
import { MdDragIndicator } from "react-icons/md";
import ReactDragListView from "react-drag-listview/lib/index.js";
import lineAccordion from "../../assets/image/lineAccordion.png";
import arrowupAndDownIcon from "../../assets/image/arrowupAndDown.png";

function useForceUpdate() {
  const [value, setState] = useState(true);
  return () => setState(!value);
}

const HasMany = (props) => {
  const [dataArray, setDataArray] = useState([]);
  const handleForceupdateMethod = useForceUpdate();
  const [selectSearchData, setSelectSearchData] = useState({});
  const [accordionStateHandler, setAccordionStateHandler] = useState(false);
  const hasManyRef = useRef();
  const listRef = useRef();
  const [refScrollHeight, setRefScrollHeight] = useState(0);
  const [listScrollHeight, setListScrollHeight] = useState(0);

  const accordionHandler = () => {
    if (dataArray.length === 0) return;
    setAccordionStateHandler((prev) => !prev);
  };

  useEffect(() => {
    setRefScrollHeight(hasManyRef.current.scrollHeight);
  }, [addForm, deleteForm, dataArray]);

  useEffect(() => {
    if (dataArray.length === 0) {
      setAccordionStateHandler(false);
    } else if (dataArray.length >= 1) {
      setAccordionStateHandler(true);
    }
  }, [dataArray]);

  function HasManyInputData(index, key, value) {
    let array = dataArray;
    array[index].object[key] = value;
    setDataArray(array);
    let array2 = array.map((item) => item.object);
    let hasManyInputData = props.inputData;
    hasManyInputData[props.keyValue] = array2;
    props.setInputData(hasManyInputData);
  }

  // function setColStyle() {
  //   if (document.getElementById(props.id)) {
  //     props.item.col
  //       ? document.getElementById(props.id).classList.add(`col-${props.item.col}`)
  //       : document.getElementById(props.id).classList.add(`col-${12}`);
  //   }
  // }

  function addForm(type, mapIndex) {
    setListScrollHeight(0);
    let array = dataArray;
    let object = {};
    if (type === "edit") {
      props.data.map((item, index) => {
        object[item.key] = props.editDataValue[mapIndex][item.key];
      });
    } else {
      props.data.map((item) => (object[item.key] = ""));
    }
    array.sort(function (a, b) {
      return a.id - b.id;
    });
    let object2 = {};
    object2.object = object;
    if (array.length > 0) {
      object2.id = array.at(-1).id + 1;
    } else {
      object2.id = 0;
    }
    array.push(object2);
    setDataArray(array);
    let array2 = array.map((item) => item.object);
    let hasManyInputData = props.inputData;
    hasManyInputData[props.keyValue] = array2;
    props.setInputData(hasManyInputData);
    // setColStyle()
    handleForceupdateMethod();
  }

  function deleteForm(event) {
    if (listRef?.current?.scrollHeight) {
      setListScrollHeight(
        listScrollHeight + listRef?.current?.scrollHeight + 60,
      );
    }
    let array = dataArray;
    let array2 = array.filter((item) => +item.id !== +event.target.id);
    setDataArray(array2);
    let array3 = array2.map((item) => item.object);
    let hasManyInputData = props.inputData;
    hasManyInputData[props.keyValue] = array3;
    props.setInputData(hasManyInputData);
    handleForceupdateMethod();
  }

  useEffect(() => {
    if (props.pageType === "edit" && props.editDataValue) {
      props.editDataValue.map((item, index) => addForm("edit", index));
    } else {
      addForm();
    }
  }, []);

  function onDragEnd(fromIndex, toIndex) {
    const newData = [...dataArray];
    const item = newData.splice(fromIndex, 1)[0];
    newData.splice(toIndex, 0, item);
    setDataArray(newData);
    let array = newData.map((item) => item.object);
    let hasManyInputData = props.inputData;
    hasManyInputData[props.keyValue] = array;
    props.setInputData(hasManyInputData);
    handleForceupdateMethod();
  }
  return (
    <div className={"relative mb-10 mt-7"}>
      <div
        className={
          "w-full h-[60px] rounded-[8px] cursor-pointer overflow-hidden absolute top-0 right-0 left-0"
        }
        onClick={accordionHandler}
      >
        <p
          className={
            "relative h-full flex items-center justify-center text-white"
          }
        >
          <img src={lineAccordion} alt="not fount" className="w-full h-full" />
          {/*{accordionStateHandler ? "بستن" : "باز کردن"}*/}
          <div className="absolute top-11 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <img
              src={arrowupAndDownIcon}
              alt="not fount"
              className={`w-5 h-5 ${accordionStateHandler ? "rotate-0" : "rotate-180"} transition-all duration-300`}
            />
          </div>
        </p>
      </div>
      <div
        ref={hasManyRef}
        className={
          "col-span-full grid grid-cols-1 gap-y-5 rounded-[8px] transition-all duration-300 overflow-hidden"
        }
        style={
          accordionStateHandler
            ? { height: refScrollHeight - listScrollHeight }
            : { height: 0 }
        }
      >
        <ReactDragListView
          onDragEnd={(romIndex, toIndex) => {
            onDragEnd(romIndex, toIndex);
          }}
          nodeSelector="section"
          handleSelector="button"
        >
          {dataArray &&
            dataArray.map((item, index) => (
              <section
                ref={listRef}
                className="bg-hasMany_background shadow-box dark:bg-[#476D7C] px-5 py-3 rounded-lg mb-5 mt-16"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
              >
                <div className="flex justify-between items-center">
                  {props?.item?.removeItem && (
                    <TiDelete
                      className=" text-[25px] text-red-600 cursor-pointer"
                      id={item.id}
                      onClick={deleteForm}
                    />
                  )}
                  {props.item.drag === true ||
                  props.item.drag === "1" ||
                  props.item.drag === "true" ||
                  props.item.drag === 1 ? (
                    <button>
                      <MdDragIndicator className="text-[25px] rotate-90" />
                    </button>
                  ) : (
                    ""
                  )}
                </div>
                <div className="grid grid-cols-1 560:grid-cols-12 justify-between items-start gap-7">
                  {props &&
                    props.data.map((item1, index1) => (
                      <EditInputComponent
                        pageType={props.pageType}
                        item={item1}
                        key={item1.key}
                        HasManyData={item.object}
                        inputData={props.inputData}
                        setInputData={props.setInputData}
                        HasManyInputData={HasManyInputData}
                        index={item.id}
                        HasManyKey={item1.key}
                        editDataValue={item.object[item1.key]}
                        matchpointId={"matchpoint" + index1}
                        id={`${props.id}-${item1.controlType}-${index1}-${index}`}
                        setSelectSearchData={setSelectSearchData}
                        selectSearchData={selectSearchData}
                      />
                    ))}
                </div>
              </section>
            ))}
          {(!props.item.max || dataArray.length < props.item.max) &&
            props?.item?.addButton && (
              <button
                disabled={!props?.item?.addButton && !accordionStateHandler}
                className={`w-full ${accordionStateHandler ? "h-[40px] bg-hasMany_button -bottom-10" : "h-[32px] bg-hasMany_accordion_open -bottom-[32px] hidden"} ${props?.item?.addButton ? "hover:bg-red-500" : ""} dark:bg-[#73b3c2] mt-[-15px] rounded-lg text-hasMany_text absolute`}
                onClick={() => {
                  setAccordionStateHandler(true);
                  addForm("add");
                }}
              >
                {props?.item?.addButton ? "افزودن" : ""}
              </button>
            )}
        </ReactDragListView>
      </div>
    </div>
  );
};

export default HasMany;
